import { useState } from 'react';

import Input from '@cartwhl/ui/atoms/Input';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { characterPickerStore, noticesStore } from 'stores';

export default function CharacterRenameModal({
  close,
  payload,
}: {
  close: () => void;
  payload: { characterID: string; characterName: string };
}) {
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      close();
    }
  };

  const [newName, setNewName] = useState(payload.characterName);
  const [loading, setLoading] = useState(false);

  const submitNameChange = async () => {
    setLoading(true);
    if (newName.length > 100) {
      noticesStore.error(
        `Name must be less than 100 characters. ${newName.length} characters entered.`,
      );
      return;
    }
    if (newName.length === 0) {
      noticesStore.error('Name must not be empty.');
      return;
    }
    await characterPickerStore.renameCustomCharacter(
      payload.characterID,
      newName,
    );
    setLoading(false);
    close();
  };

  return (
    <Modal
      title={`Rename Character`}
      open={true}
      onOpenChange={handleOpenChange}
    >
      <div>
        <Input
          autoFocus={newName === payload.characterName}
          name="text"
          label="Character Name"
          value={newName}
          className="mb-8 mt-4"
          onChange={(e) => setNewName(e.target.value)}
          placeholder="Updated character name"
        />
      </div>
      <div className="mt-6 flex justify-end">
        <Button loading={loading} variant="primary" onClick={submitNameChange}>
          Rename
        </Button>
      </div>
    </Modal>
  );
}
